export type AppThemePreference = "light" | "dark" | "system";
export type ResolvedAppTheme = "light" | "dark";

export const APP_THEME_STORAGE_KEY = "supplyspark-ui-theme";

export function getStoredAppThemePreference(): AppThemePreference {
  if (typeof window === "undefined") {
    return "system";
  }

  const storedTheme = window.localStorage.getItem(APP_THEME_STORAGE_KEY);
  return normalizeAppThemePreference(storedTheme);
}

export function resolveSentryFeedbackColorScheme(
  theme: string | null | undefined,
  resolvedTheme: string | null | undefined,
): ResolvedAppTheme {
  const normalizedTheme = normalizeAppThemePreference(theme);
  if (normalizedTheme === "dark") {
    return "dark";
  }

  if (normalizedTheme === "light") {
    return "light";
  }

  return resolvedTheme === "dark" ? "dark" : "light";
}

export function getInitialSentryFeedbackColorScheme(): ResolvedAppTheme {
  const storedTheme = getStoredAppThemePreference();
  return resolveSentryFeedbackColorScheme(storedTheme, getSystemResolvedTheme());
}

function getSystemResolvedTheme(): ResolvedAppTheme {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return "light";
  }

  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

function normalizeAppThemePreference(theme: string | null | undefined): AppThemePreference {
  if (theme === "light" || theme === "dark" || theme === "system") {
    return theme;
  }

  return "system";
}
